import {EquipmentCardEnums, EquipmentCardInterfaces, EquipmentEnums} from '@namespaces/equipment.namespace';
import {ApiModel} from '../api-model';

export class Calibration extends ApiModel<EquipmentCardInterfaces.Card.LastCalibration> {
    /**
     * Дата окончания калибровки/поверки
     */
    public dateEnd: string;

    /**
     * Сообщение статуса поверки, например:
     * 'Поверено до 11.11.11' или
     * 'Калибровка просрочена'
     */
    public status: string;

    /**
     * Просрочена?
     */
    public isExpired: boolean;

    private statusId: EquipmentCardEnums.CalibrationExpiredStatus;


    public cssClassForMessage: string;

    constructor(
        _rawData: EquipmentCardInterfaces.Card.LastCalibration,
        private verificationStatus: EquipmentEnums.VerificationStatus
    ) {
        super(_rawData);
        this.setAttributes();
    }

    /**
     * Выбрать label для поверки или калбировке, в зависимости от статуса (поверяется или калибруется)
     * @param status
     * @param ongoingLabel
     * @param calibratedLabel
     * @param defaultLabel
     */
    static getCalibrationLabel(
        status: EquipmentEnums.VerificationStatus,
        ongoingLabel: string,
        calibratedLabel: string,
        defaultLabel?: string
    ): string {
        if (status === EquipmentEnums.VerificationStatus.ongoing) {
            return ongoingLabel;
        }

        if (status === EquipmentEnums.VerificationStatus.calibrating) {
            return calibratedLabel;
        }

        return defaultLabel || ongoingLabel;
    }

    protected setAttributes() {
        this.dateEnd = this.rawData.date_end;
        this.statusId = +this.rawData.status;
        this.isExpired = this.statusId === EquipmentCardEnums.CalibrationExpiredStatus.expired;
        this.status = this.getStatusMessage();
        this.cssClassForMessage = this.getCssClassForMessage();
    }

    private getStatusMessage(): string {
        if (this.isExpired) {
            return `${Calibration.getCalibrationLabel(this.verificationStatus, 'Поверка', 'Калиброка')} просрочена`;
        } else {
            return `${Calibration.getCalibrationLabel(this.verificationStatus, 'Поверено', 'Откалибровано')} до ${this.dateEnd}`;
        }
    }

    private getCssClassForMessage(): string {
        if (
            [
                EquipmentCardEnums.CalibrationExpiredStatus.close,
                EquipmentCardEnums.CalibrationExpiredStatus.expired
            ].includes(this.statusId)
        ) {
            return 'error';
        }

        if (this.statusId === EquipmentCardEnums.CalibrationExpiredStatus.soon) {
            return 'warning';
        }

        return '';
    }
}
